export const QUERY_KEYS = {
  AUTH_CURRENT_GET: "AUTH_CURRENT_GET",
  AUTH_LOGIN_POST: "AUTH_LOGIN_POST",
  SAKUSAS_EDITABLE_TEXT_GET: "SAKUSAS_EDITABLE_TEXT_GET",
  SAKUSAS_VIDEO_GET: "SAKUSAS_VIDEO_GET",
  SAKUSAS_VIDEO_SEARCH: "SAKUSAS_VIDEO_SEARCH",
  SAKUSAS_POSITION_GET: "SAKUSAS_POSITION_GET",
  SAKUSAS_POSITION_SEARCH: "SAKUSAS_POSITION_SEARCH",
  SAKUSAS_PANEL_GET: "SAKUSAS_PANEL_GET",
  SAKUSAS_PANEL_SEARCH: "SAKUSAS_PANEL_SEARCH",
  TEST_CONTENT_GET: "TEST_CONTENT_GET",
};
